import { SVGProps } from "react";

export const ImportIcon = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12"
      stroke={"#000000"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 4L12 14M12 14L15 11M12 14L9 11"
      stroke={"#000000"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadFile = () => (
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M736.68 435.86a173.773 173.773 0 0 1 172.042 172.038c0.578 44.907-18.093 87.822-48.461 119.698-32.761 34.387-76.991 51.744-123.581 52.343-68.202 0.876-68.284 106.718 0 105.841 152.654-1.964 275.918-125.229 277.883-277.883 1.964-152.664-128.188-275.956-277.883-277.879-68.284-0.878-68.202 104.965 0 105.842zM285.262 779.307A173.773 173.773 0 0 1 113.22 607.266c-0.577-44.909 18.09-87.823 48.461-119.705 32.759-34.386 76.988-51.737 123.58-52.337 68.2-0.877 68.284-106.721 0-105.842C132.605 331.344 9.341 454.607 7.379 607.266 5.417 759.929 135.565 883.225 285.262 885.148c68.284 0.876 68.2-104.965 0-105.841z"
      fill={"#000000"}
    />
    <path
      d="M339.68 384.204a173.762 173.762 0 0 1 172.037-172.038c44.908-0.577 87.822 18.092 119.698 48.462 34.388 32.759 51.743 76.985 52.343 123.576 0.877 68.199 106.72 68.284 105.843 0-1.964-152.653-125.231-275.917-277.884-277.879-152.664-1.962-275.954 128.182-277.878 277.879-0.88 68.284 104.964 68.199 105.841 0z"
      fill="#C45FA0"
    />
    <path
      d="M545.039 473.078c16.542 16.542 16.542 43.356 0 59.896l-122.89 122.895c-16.542 16.538-43.357 16.538-59.896 0-16.542-16.546-16.542-43.362 0-59.899l122.892-122.892c16.537-16.542 43.355-16.542 59.894 0z"
      fill="#F39A2B"
    />
    <path
      d="M485.17 473.078c16.537-16.539 43.354-16.539 59.892 0l122.896 122.896c16.538 16.533 16.538 43.354 0 59.896-16.541 16.538-43.361 16.538-59.898 0L485.17 532.979c-16.547-16.543-16.547-43.359 0-59.901z"
      fill="#F39A2B"
    />
    <path
      d="M514.045 634.097c23.972 0 43.402 19.433 43.402 43.399v178.086c0 23.968-19.432 43.398-43.402 43.398-23.964 0-43.396-19.432-43.396-43.398V677.496c0.001-23.968 19.433-43.399 43.396-43.399z"
      fill="#E5594F"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
      fill="#000"
    />
  </svg>
);
export const DoneIcon = (props: any) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 14L8.23309 16.4248C8.66178 16.7463 9.26772 16.6728 9.60705 16.2581L18 6"
      stroke="#8676F1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const PaymentType = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.3125 14.0682C19.8303 14.0682 20.25 14.4879 20.25 15.0057V16.1307C20.25 16.6485 19.8303 17.0682 19.3125 17.0682H17.1562C16.6384 17.0682 16.2188 16.6485 16.2188 16.1307V15.0057C16.2188 14.4879 16.6384 14.0682 17.1562 14.0682H19.3125ZM22.125 12.3807V9.56818H1.875V17.0625C1.875 18.0963 2.71619 18.9375 3.75 18.9375H20.25C21.2838 18.9375 22.125 18.0963 22.125 17.0625C22.125 16.5447 22.5447 16.125 23.0625 16.125C23.5803 16.125 24 16.5447 24 17.0625C24 19.1303 22.3178 20.8125 20.25 20.8125H3.75C1.68219 20.8125 0 19.1303 0 17.0625V6.9375C0 4.86969 1.68219 3.1875 3.75 3.1875H20.25C22.3178 3.1875 24 4.86969 24 6.9375V12.3807C24 12.8985 23.5803 13.3182 23.0625 13.3182C22.5447 13.3182 22.125 12.8985 22.125 12.3807ZM22.125 7.69318V6.9375C22.125 5.90369 21.2838 5.0625 20.25 5.0625H3.75C2.71619 5.0625 1.875 5.90369 1.875 6.9375V7.69318H22.125ZM4.6875 11.4432C4.16968 11.4432 3.75 11.8629 3.75 12.3807C3.75 12.8985 4.16968 13.3182 4.6875 13.3182H12.4219C12.9397 13.3182 13.3594 12.8985 13.3594 12.3807C13.3594 11.8629 12.9397 11.4432 12.4219 11.4432H4.6875Z" fill="#EB5A02" />
  </svg>

)

export const DashboardIconMain = () => (
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.3565 4C6.80817 4 3.12122 7.68695 3.12122 12.2353C3.12122 13.5539 3.38566 14.8688 3.90142 16.0271C4.22896 16.7627 4.39274 17.1305 5.06227 17.5653C5.73181 18 6.33504 18 7.54151 18H15.1711C16.3778 18 16.9811 18 17.6507 17.5652C18.3203 17.1304 18.4841 16.7625 18.8117 16.0266C19.3273 14.8684 19.5919 13.5537 19.5919 12.2353C19.5919 7.68695 15.9049 4 11.3565 4Z" stroke="#FF8A32" stroke-width="1.3476" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.3565 15.1177C12.2662 15.1177 13.0036 14.3803 13.0036 13.4706C13.0036 12.561 12.2662 11.8235 11.3565 11.8235C10.4469 11.8235 9.70947 12.561 9.70947 13.4706C9.70947 14.3803 10.4469 15.1177 11.3565 15.1177Z" stroke="#FF8A32" stroke-width="1.3476" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.3565 9.35297V11.8236M11.3565 6.05884V6.88237M5.18005 12.6471H6.00359M6.82712 8.52943L7.40935 9.11167M16.7095 12.6471H17.533M15.4742 9.11167L16.0564 8.52943" stroke="#FF8A32" stroke-width="1.3476" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);
export const RatingIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13.4984L14.125 15.1234C14.225 15.2068 14.325 15.2111 14.425 15.1364C14.525 15.0618 14.5583 14.9658 14.525 14.8484L13.7 12.1984L15.925 10.4484C16.0083 10.3651 16.0333 10.2691 16 10.1604C15.9667 10.0518 15.8917 9.99777 15.775 9.99844H13.1L12.25 7.32344C12.2167 7.20677 12.1333 7.14844 12 7.14844C11.8667 7.14844 11.7833 7.20677 11.75 7.32344L10.9 9.99844H8.225C8.10833 9.99844 8.029 10.0528 7.987 10.1614C7.945 10.2701 7.966 10.3658 8.05 10.4484L10.25 12.1984L9.425 14.8734C9.39167 14.9901 9.425 15.0861 9.525 15.1614C9.625 15.2368 9.725 15.2324 9.825 15.1484L12 13.4984ZM12 21.8984C11.8833 21.8984 11.775 21.8901 11.675 21.8734C11.575 21.8568 11.475 21.8318 11.375 21.7984C9.125 21.0484 7.33333 19.6608 6 17.6354C4.66667 15.6101 4 13.4311 4 11.0984V6.37344C4 5.95677 4.121 5.58177 4.363 5.24844C4.605 4.9151 4.91733 4.67344 5.3 4.52344L11.3 2.27344C11.5333 2.1901 11.7667 2.14844 12 2.14844C12.2333 2.14844 12.4667 2.1901 12.7 2.27344L18.7 4.52344C19.0833 4.67344 19.396 4.9151 19.638 5.24844C19.88 5.58177 20.0007 5.95677 20 6.37344V11.0984C20 13.4318 19.3333 15.6111 18 17.6364C16.6667 19.6618 14.875 21.0491 12.625 21.7984C12.525 21.8318 12.425 21.8568 12.325 21.8734C12.225 21.8901 12.1167 21.8984 12 21.8984Z" fill="#EB5B00"></path></svg>
  )
}
export const IntegrationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1898 8.45203V6.63227H7.45148V8.45203H20.1898ZM20.1898 15.7311V11.1817H7.45148V15.7311H20.1898ZM20.1898 4.8125C20.6725 4.8125 21.1353 5.00422 21.4766 5.3455C21.8179 5.68677 22.0096 6.14963 22.0096 6.63227V15.7311C22.0096 16.2137 21.8179 16.6766 21.4766 17.0179C21.1353 17.3591 20.6725 17.5509 20.1898 17.5509H7.45148C6.44151 17.5509 5.63172 16.732 5.63172 15.7311V6.63227C5.63172 5.6223 6.44151 4.8125 7.45148 4.8125H20.1898ZM3.81195 19.3706H17.4602V21.1904H3.81195C3.32932 21.1904 2.86646 20.9987 2.52518 20.6574C2.18391 20.3161 1.99219 19.8533 1.99219 19.3706V9.36191H3.81195V19.3706Z"
        fill="#EB5B00"
      />
    </svg>
  )
}

export const OrderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.85938 3.79688C3.32344 5.26406 1.21875 6.50156 1.18594 6.54375C1.13906 6.60938 1.125 7.725 1.125 12.0047C1.125 17.0578 1.12969 17.3859 1.20938 17.475C1.33594 17.6203 10.4766 22.875 10.5984 22.875C10.6594 22.875 11.4891 22.4203 12.4453 21.8719L14.175 20.8687L14.5641 21.2812C15.0516 21.7969 15.4734 22.1156 16.0359 22.3781C17.8828 23.2547 20.0203 22.8891 21.45 21.45C21.8859 21.0094 22.1578 20.625 22.4109 20.0906C23.3531 18.075 22.7531 15.6234 20.9906 14.2969C20.7844 14.1375 20.4891 13.95 20.3391 13.8703L20.0625 13.7344V10.1766C20.0625 6.85781 20.0578 6.61406 19.9828 6.525C19.8516 6.375 10.7156 1.125 10.5891 1.125C10.5281 1.12969 8.4 2.32969 5.85938 3.79688ZM14.7563 4.33594C17.0297 5.64844 18.8906 6.73594 18.8906 6.75C18.8906 6.77812 14.8734 9.10781 14.7844 9.13125C14.7141 9.15 7.02188 4.02656 7.05469 3.98906C7.10625 3.9375 10.5703 1.93125 10.5984 1.94062C10.6125 1.94062 12.4828 3.01875 14.7563 4.33594ZM10.1391 6.98906C12.2297 8.38594 13.9594 9.53906 13.9828 9.55781C14.0016 9.57656 13.2469 10.0359 12.3047 10.5797L10.5938 11.5687L9.24375 10.7859C8.50313 10.3594 6.6375 9.28125 5.09531 8.39062C3.55781 7.5 2.29688 6.76406 2.29688 6.75C2.29688 6.7125 6.20156 4.45781 6.27188 4.45781C6.3 4.45312 8.04375 5.59687 10.1391 6.98906ZM6.31875 9.96094L10.2188 12.2109V17.0297C10.2188 19.6828 10.2047 21.8391 10.1859 21.8297C10.1625 21.8203 9.80156 21.6094 9.375 21.3609C7.04531 20.0156 6.23438 19.5469 4.15781 18.3516L1.87969 17.0391L1.875 12.2203V7.40156L2.14688 7.55625C2.29688 7.64062 4.17656 8.72344 6.31875 9.96094ZM19.2938 13.4391C19.2797 13.4531 19.0781 13.4297 18.8391 13.3875C17.5125 13.1578 16.1531 13.5234 15.0797 14.3906C14.3203 15.0047 13.7297 15.9281 13.4672 16.8984C13.3594 17.3062 13.3453 17.4609 13.3406 18.0703C13.3406 18.8484 13.3969 19.1531 13.65 19.8187C13.7297 20.0297 13.7859 20.2125 13.7766 20.2219C13.7625 20.2359 12.1453 21.1734 11.0063 21.8297C10.9828 21.8391 10.9688 19.6828 10.9688 17.0297L10.9734 12.2109L12.6469 11.2406L14.3203 10.2703L14.3438 11.8219L14.3672 13.3687L14.4797 13.4578C14.6297 13.5797 14.8406 13.5703 14.9766 13.4297L15.0938 13.3172V11.5687V9.82031L17.1938 8.61094L19.2891 7.40625L19.3031 10.4156C19.3078 12.0656 19.3031 13.4297 19.2938 13.4391ZM18.7031 14.1094C20.2688 14.3578 21.4922 15.4406 21.9703 17.0016C22.0781 17.3672 22.0922 17.4891 22.0922 18.0938C22.0922 18.6984 22.0781 18.8203 21.9656 19.1953C21.5484 20.5687 20.5688 21.5484 19.1953 21.9656C18.8203 22.0781 18.6984 22.0922 18.0938 22.0922C17.4891 22.0922 17.3672 22.0781 17.0016 21.9703C14.5078 21.2109 13.3453 18.5016 14.5359 16.2187C15.3141 14.7188 17.0391 13.8469 18.7031 14.1094Z"
        fill="black"
      />
      <path
        d="M20.0063 15.9939C19.9688 16.0268 19.4438 16.7064 18.8438 17.508C18.2391 18.3049 17.7047 19.0174 17.6438 19.0877L17.5453 19.2096L16.9219 18.4783C16.2609 17.6908 16.1156 17.5783 15.9 17.6814C15.7406 17.7611 15.6328 17.9533 15.6703 18.0986C15.7125 18.2486 17.2359 20.0627 17.4047 20.1564C17.5172 20.2174 17.5453 20.2174 17.6625 20.1564C17.7328 20.1143 18.3609 19.3314 19.0547 18.4174C19.7531 17.4986 20.3766 16.683 20.4516 16.5986C20.6953 16.308 20.5734 15.9377 20.2359 15.9377C20.1516 15.9377 20.0484 15.9658 20.0063 15.9939Z"
        fill="black"
      />
    </svg>
  );
};
export const CategoryIcon = () => {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.686 3.04c-.736.111-1.31.595-1.575 1.327C3.02 4.62 3.02 4.621 3.02 7s0 2.38.091 2.633c.225.621.635 1.031 1.254 1.255l.255.092h4.76l.255-.092c.619-.224 1.029-.634 1.254-1.255.091-.253.091-.254.091-2.633s0-2.38-.091-2.633c-.225-.621-.636-1.032-1.254-1.254-.254-.092-.267-.092-2.495-.099-1.232-.003-2.336.008-2.454.026m10 0c-.736.111-1.31.595-1.575 1.327-.091.253-.091.254-.091 2.633s0 2.38.091 2.633c.225.621.635 1.031 1.254 1.255l.255.092h4.76l.255-.092c.619-.224 1.029-.634 1.254-1.255.091-.253.091-.254.091-2.633s0-2.38-.091-2.633c-.225-.621-.636-1.032-1.254-1.254-.254-.092-.267-.092-2.495-.099-1.232-.003-2.336.008-2.454.026M9 7v2H5V5h4v2m10 0v2h-4V5h4v2M4.686 13.04c-.736.111-1.31.595-1.575 1.327-.091.253-.091.254-.091 2.633s0 2.38.091 2.633c.225.621.635 1.031 1.254 1.255l.255.092h4.76l.255-.092c.619-.224 1.029-.634 1.254-1.255.091-.253.091-.254.091-2.633s0-2.38-.091-2.633c-.225-.621-.636-1.032-1.254-1.254-.254-.092-.267-.092-2.495-.099-1.232-.003-2.336.008-2.454.026m10 0c-.736.111-1.31.595-1.575 1.327-.091.253-.091.254-.091 2.633s0 2.38.091 2.633c.225.621.635 1.031 1.254 1.255l.255.092h4.76l.255-.092c.619-.224 1.029-.634 1.254-1.255.091-.253.091-.254.091-2.633s0-2.38-.091-2.633c-.225-.621-.636-1.032-1.254-1.254-.254-.092-.267-.092-2.495-.099-1.232-.003-2.336.008-2.454.026M9 17v2H5v-4h4v2m10 0v2h-4v-4h4v2"
        fillRule="evenodd"
        fill="#EB5B00"
      />
    </svg>
  );
};
export const AboutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9312 0.107815C10.828 0.215626 10.828 0.243752 10.828 1.56094V2.90625H9.31398C8.08117 2.90625 7.78117 2.92031 7.70617 2.97188C7.62179 3.0375 7.61711 3.13594 7.60304 6.34688L7.59367 9.65625H6.26242H4.92648L4.83273 9.77813L4.73429 9.90469V16.6453V23.3906H3.37492H2.01554V22.5469V21.7031L2.14679 21.6703C2.62492 21.5531 3.06086 21.1922 3.29054 20.7281C3.43117 20.4469 3.44523 20.3766 3.44523 19.9922C3.44523 19.6078 3.43117 19.5375 3.29054 19.2563C3.18273 19.0359 3.05148 18.8625 2.85461 18.6844C2.61086 18.4641 2.58273 18.4266 2.66242 18.4031C2.81711 18.3516 3.18742 17.9203 3.31867 17.6344C3.42648 17.4047 3.44523 17.3063 3.44523 16.9453C3.44523 16.5797 3.42648 16.4859 3.30929 16.2328C2.98586 15.5344 2.24523 15.1266 1.48117 15.2391C0.337419 15.3984 -0.323519 16.6594 0.187419 17.7047C0.323356 17.9766 0.735856 18.4219 0.857731 18.4219C0.885856 18.4219 0.778044 18.5391 0.618669 18.6797C-0.0188311 19.2609 -0.168831 20.0859 0.224919 20.8266C0.426481 21.2016 0.909294 21.5719 1.32648 21.675L1.45304 21.7031V22.5469V23.3906H0.848356C0.309294 23.3906 0.234294 23.4 0.121794 23.4891C-0.0235186 23.6063 -0.0375811 23.775 0.0936689 23.9063C0.187419 24 0.248357 24 11.9999 24C23.7515 24 23.8124 24 23.9062 23.9063C24.0374 23.775 24.0234 23.6063 23.878 23.4891C23.7655 23.4 23.6905 23.3906 23.1515 23.3906H22.5468V22.5469V21.7031L22.678 21.675C23.0905 21.5719 23.5734 21.2016 23.7749 20.8266C24.1687 20.0859 24.0187 19.2609 23.3812 18.6797C23.2218 18.5391 23.114 18.4219 23.1421 18.4219C23.264 18.4219 23.6765 17.9766 23.8124 17.7047C24.5202 16.2563 23.0202 14.7141 21.539 15.3703C21.2202 15.5109 20.8452 15.8906 20.6905 16.2328C20.5734 16.4859 20.5546 16.5797 20.5546 16.9453C20.5546 17.3063 20.5734 17.4047 20.6812 17.6344C20.8124 17.9203 21.1827 18.3516 21.3374 18.4031C21.4171 18.4266 21.389 18.4641 21.1452 18.6844C20.9484 18.8625 20.8171 19.0359 20.7093 19.2563C20.5687 19.5375 20.5546 19.6078 20.5546 19.9922C20.5546 20.3766 20.5687 20.4469 20.7093 20.7281C20.939 21.1922 21.3749 21.5531 21.8577 21.6703L21.9843 21.7031V22.5469V23.3906H20.6249H19.2655L19.2562 13.7766C19.2421 4.32188 19.2421 4.1625 19.153 4.09688C19.1015 4.05938 19.0124 4.03125 18.9562 4.03125C18.8952 4.03125 17.8874 4.43906 16.7155 4.94063L14.578 5.84531V4.54219C14.578 3.27188 14.5546 3.02813 14.4234 2.94375C14.3905 2.925 13.7062 2.90625 12.9046 2.90625H11.4374V1.55625V0.201565L11.3296 0.103127C11.189 -0.0281239 11.0577 -0.0281239 10.9312 0.107815ZM13.9593 4.62656L13.9687 5.76563H11.0859H8.20304V4.61719V3.46875L11.0765 3.47813L13.9452 3.49219L13.9593 4.62656ZM18.6562 14.0859V23.3906H17.8124H16.9687V21.8484C16.9687 20.4 16.964 20.3016 16.8796 20.1984L16.7905 20.0859H14.939C13.1859 20.0859 13.0827 20.0906 12.989 20.175C12.8905 20.2641 12.8905 20.2969 12.8905 21.8297V23.3906H12.0468H11.203V15.6609V7.93594L12.3187 7.4625C12.928 7.2 14.5921 6.49219 16.0077 5.8875C17.428 5.28281 18.5999 4.78594 18.6234 4.78594C18.6421 4.78125 18.6562 8.96719 18.6562 14.0859ZM13.2187 6.41719C13.1812 6.44063 12.6093 6.68438 11.953 6.96094C11.2968 7.2375 10.7202 7.5 10.678 7.5375C10.603 7.60313 10.5937 7.71563 10.5937 8.63438V9.65625H9.39836H8.20304V8.01563V6.375H10.7484C12.1546 6.375 13.2562 6.39375 13.2187 6.41719ZM10.5937 16.8281V23.3906H7.96867H5.34367V16.8281V10.2656H7.96867H10.5937V16.8281ZM2.24992 15.9375C2.78898 16.2094 3.00929 16.8656 2.74679 17.4141C2.54523 17.8406 2.19836 18.0609 1.73429 18.0563C1.27492 18.0563 0.909294 17.8266 0.721794 17.4141C0.271794 16.4531 1.30304 15.4547 2.24992 15.9375ZM22.7765 15.9375C23.6202 16.3688 23.5687 17.6203 22.6874 17.9906C22.4671 18.0797 22.0499 18.075 21.8202 17.9813C21.1359 17.6906 20.9155 16.7578 21.4077 16.2141C21.7734 15.8109 22.3171 15.6984 22.7765 15.9375ZM2.06711 18.9188C2.53117 19.0547 2.85929 19.5 2.85929 19.9875C2.85929 20.4234 2.57336 20.8688 2.19367 21.0234C1.93586 21.1266 1.52804 21.1313 1.28898 21.0281C0.717106 20.7844 0.454606 20.0906 0.721794 19.5234C0.867106 19.2188 1.06398 19.0406 1.36867 18.9328C1.67804 18.825 1.74836 18.825 2.06711 18.9188ZM22.5843 18.9141C23.2405 19.1109 23.5687 19.8469 23.278 20.4609C23.0765 20.8875 22.7296 21.1078 22.2655 21.1078C21.9187 21.1078 21.6468 20.9859 21.4312 20.7375C20.8968 20.1328 21.1359 19.1953 21.8905 18.9375C22.2093 18.825 22.2796 18.825 22.5843 18.9141ZM16.3593 22.0313V23.3906H14.9062H13.453V22.0641C13.453 21.3328 13.4671 20.7188 13.4859 20.7047C13.4999 20.6859 14.1562 20.6719 14.939 20.6719H16.3593V22.0313Z"
      fill="black"
    />
    <path
      d="M12.5436 10.4156C12.4452 10.5562 12.4499 10.6687 12.5624 10.7812C12.6514 10.8703 12.717 10.875 14.9202 10.875C17.0577 10.875 17.1936 10.8703 17.2639 10.7906C17.3624 10.6828 17.367 10.4812 17.2686 10.3875C17.203 10.3219 16.9264 10.3125 14.9061 10.3125H12.6139L12.5436 10.4156Z"
      fill="black"
    />
    <path
      d="M12.5625 12.1877C12.4359 12.3143 12.4453 12.4502 12.5859 12.5908L12.7031 12.708L14.9578 12.6939C17.1281 12.6799 17.2125 12.6752 17.2781 12.5908C17.3672 12.4643 17.3625 12.2627 17.2594 12.1736C17.1797 12.1033 16.95 12.0939 14.9156 12.0939C12.7172 12.0939 12.6515 12.0986 12.5625 12.1877Z"
      fill="black"
    />
    <path
      d="M12.5625 14.0152C12.4312 14.1464 12.4453 14.3152 12.5953 14.437C12.7171 14.5308 12.7453 14.5355 14.9671 14.5214C17.1281 14.5073 17.2125 14.5027 17.2781 14.4183C17.3671 14.2917 17.3625 14.0902 17.2593 14.0011C17.1796 13.9308 16.95 13.9214 14.9156 13.9214C12.7171 13.9214 12.6515 13.9261 12.5625 14.0152Z"
      fill="black"
    />
    <path
      d="M12.6701 15.75C12.4686 15.8344 12.4123 16.0687 12.5623 16.2188C12.6514 16.3078 12.717 16.3125 14.9201 16.3125C17.0576 16.3125 17.1936 16.3078 17.2639 16.2281C17.3482 16.1391 17.367 15.9516 17.3061 15.8625C17.2076 15.7125 17.0623 15.7031 14.9201 15.7078C13.7389 15.7078 12.7264 15.7266 12.6701 15.75Z"
      fill="black"
    />
    <path
      d="M12.5624 17.6247C12.4452 17.7419 12.4452 17.8638 12.5577 18.0044L12.6467 18.1169L14.7749 18.131C15.9421 18.1404 16.9639 18.131 17.0483 18.1169C17.2452 18.0841 17.3436 17.981 17.3436 17.8169C17.3436 17.5263 17.3999 17.531 14.9155 17.531C12.717 17.531 12.6514 17.5357 12.5624 17.6247Z"
      fill="black"
    />
    <path
      d="M6.87656 11.8034C6.81094 11.8738 6.79688 11.9909 6.79688 12.4128C6.79688 12.8956 6.80625 12.9378 6.9 13.0034C7.18594 13.205 7.37344 13.0269 7.39687 12.5347C7.42969 11.9394 7.34531 11.7191 7.08281 11.7191C7.0125 11.7191 6.91875 11.7566 6.87656 11.8034Z"
      fill="black"
    />
    <path
      d="M8.65295 11.7894C8.55451 11.8925 8.51701 12.1269 8.54045 12.5347C8.56389 13.0269 8.75139 13.205 9.03733 13.0034C9.13576 12.9378 9.14045 12.8956 9.14045 12.4034C9.14045 11.9488 9.12639 11.8644 9.05608 11.7988C8.94826 11.7003 8.7467 11.6956 8.65295 11.7894Z"
      fill="black"
    />
    <path
      d="M6.9 13.9969C6.80156 14.0625 6.79688 14.1047 6.79688 14.5969C6.79688 15.1781 6.83906 15.2812 7.09219 15.2812C7.34531 15.2812 7.42969 15.0563 7.39688 14.4656C7.37344 13.9734 7.18594 13.7953 6.9 13.9969Z"
      fill="black"
    />
    <path
      d="M8.64355 14.0203C8.57792 14.0906 8.5498 14.2078 8.54042 14.4656C8.50761 15.0609 8.59199 15.2812 8.85449 15.2812C9.09355 15.2812 9.14042 15.1687 9.14042 14.5875C9.14042 14.1047 9.13105 14.0625 9.0373 13.9969C8.89199 13.8937 8.75136 13.9031 8.64355 14.0203Z"
      fill="black"
    />
    <path
      d="M6.96094 16.1815C6.81094 16.2659 6.79688 16.3127 6.79688 16.8284C6.79688 17.3534 6.81094 17.3909 6.975 17.4799C7.13438 17.5643 7.31719 17.4565 7.37344 17.2502C7.43438 17.0112 7.39219 16.3221 7.30781 16.2471C7.20938 16.1487 7.06406 16.1252 6.96094 16.1815Z"
      fill="black"
    />
    <path
      d="M8.7187 16.1855C8.65776 16.2183 8.59214 16.2933 8.57339 16.359C8.5312 16.509 8.5312 17.1465 8.57339 17.2965C8.61558 17.4558 8.82183 17.5543 8.96245 17.4793C9.12651 17.3902 9.14058 17.3527 9.14058 16.8277C9.14058 16.3027 9.12651 16.2605 8.96714 16.1762C8.84526 16.1152 8.85933 16.1152 8.7187 16.1855Z"
      fill="black"
    />
    <path
      d="M6.87656 18.4597C6.81094 18.53 6.79688 18.6472 6.79688 19.0691C6.79688 19.5519 6.80625 19.5941 6.9 19.6597C7.18594 19.8613 7.37344 19.6831 7.39687 19.1909C7.42969 18.5956 7.34531 18.3753 7.08281 18.3753C7.0125 18.3753 6.91875 18.4128 6.87656 18.4597Z"
      fill="black"
    />
    <path
      d="M8.65313 18.4458C8.48907 18.6098 8.48438 19.4583 8.64376 19.6364C8.75626 19.7583 8.95782 19.7629 9.06095 19.6504C9.18282 19.5192 9.17813 18.5629 9.05626 18.4551C8.94845 18.3567 8.74688 18.352 8.65313 18.4458Z"
      fill="black"
    />
    <path
      d="M6.89062 20.6719C6.80625 20.7563 6.79688 20.8266 6.79688 21.2719C6.79688 21.8344 6.84375 21.9375 7.09219 21.9375C7.34531 21.9375 7.42969 21.7125 7.39688 21.1125C7.38281 20.8078 7.36406 20.7422 7.27031 20.6672C7.12969 20.5547 7.00781 20.5547 6.89062 20.6719Z"
      fill="black"
    />
    <path
      d="M8.66699 20.6672C8.57324 20.7422 8.55449 20.8078 8.54042 21.1125C8.50761 21.7172 8.59199 21.9375 8.85449 21.9375C9.09355 21.9375 9.14042 21.825 9.14042 21.2437C9.14042 20.7609 9.13105 20.7188 9.0373 20.6531C8.89667 20.5547 8.79824 20.5594 8.66699 20.6672Z"
      fill="black"
    />
  </svg>
)

export const SettingsIcon = ({ props }: any) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.46458 3.95725C9.85508 2.34758 12.1449 2.34758 12.5354 3.95725C12.594 4.19907 12.7089 4.42363 12.8707 4.61267C13.0324 4.8017 13.2366 4.94987 13.4664 5.0451C13.6963 5.14033 13.9454 5.17995 14.1935 5.16071C14.4415 5.14148 14.6816 5.06394 14.894 4.93442C16.3084 4.07275 17.9282 5.69158 17.0665 7.10692C16.9372 7.31927 16.8597 7.55914 16.8406 7.80704C16.8214 8.05494 16.8609 8.30387 16.9561 8.5336C17.0512 8.76332 17.1992 8.96736 17.388 9.12913C17.5768 9.2909 17.8012 9.40583 18.0428 9.46458C19.6524 9.85508 19.6524 12.1449 18.0428 12.5354C17.8009 12.594 17.5764 12.7089 17.3873 12.8707C17.1983 13.0324 17.0501 13.2366 16.9549 13.4664C16.8597 13.6963 16.8201 13.9454 16.8393 14.1935C16.8585 14.4415 16.9361 14.6816 17.0656 14.894C17.9273 16.3084 16.3084 17.9282 14.8931 17.0665C14.6807 16.9372 14.4409 16.8597 14.193 16.8406C13.9451 16.8214 13.6961 16.8609 13.4664 16.9561C13.2367 17.0512 13.0326 17.1992 12.8709 17.388C12.7091 17.5768 12.5942 17.8012 12.5354 18.0428C12.1449 19.6524 9.85508 19.6524 9.46458 18.0428C9.40599 17.8009 9.29113 17.5764 9.12935 17.3873C8.96757 17.1983 8.76344 17.0501 8.53357 16.9549C8.3037 16.8597 8.0546 16.8201 7.80653 16.8393C7.55846 16.8585 7.31844 16.9361 7.106 17.0656C5.69158 17.9273 4.07183 16.3084 4.9335 14.8931C5.06284 14.6807 5.14025 14.4409 5.15944 14.193C5.17863 13.9451 5.13906 13.6961 5.04393 13.4664C4.94881 13.2367 4.80082 13.0326 4.612 12.8709C4.42318 12.7091 4.19885 12.5942 3.95725 12.5354C2.34758 12.1449 2.34758 9.85508 3.95725 9.46458C4.19907 9.40599 4.42363 9.29113 4.61267 9.12935C4.8017 8.96757 4.94987 8.76344 5.0451 8.53357C5.14033 8.3037 5.17995 8.0546 5.16071 7.80653C5.14148 7.55846 5.06394 7.31844 4.93442 7.106C4.07275 5.69158 5.69158 4.07183 7.10692 4.9335C8.02358 5.49083 9.21158 4.99767 9.46458 3.95725Z"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 11C8.25 11.7293 8.53973 12.4288 9.05546 12.9445C9.57118 13.4603 10.2707 13.75 11 13.75C11.7293 13.75 12.4288 13.4603 12.9445 12.9445C13.4603 12.4288 13.75 11.7293 13.75 11C13.75 10.2707 13.4603 9.57118 12.9445 9.05546C12.4288 8.53973 11.7293 8.25 11 8.25C10.2707 8.25 9.57118 8.53973 9.05546 9.05546C8.53973 9.57118 8.25 10.2707 8.25 11Z"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AnaliticIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49008 4.00483C8.25748 4.29048 7.12378 4.90059 6.20657 5.77187C5.28936 6.64316 4.62204 7.74389 4.27383 8.9599C3.92562 10.1759 3.90921 11.4629 4.22629 12.6874C4.54337 13.9119 5.18239 15.0293 6.07708 15.9236C6.97177 16.818 8.08954 17.4568 9.31445 17.7738C10.5394 18.0908 11.8268 18.0744 13.0432 17.7263C14.2597 17.3782 15.3608 16.7111 16.2324 15.7942C17.1039 14.8773 17.7143 13.744 18 12.5118C18 12.3029 17.917 12.1026 17.7692 11.9548C17.6214 11.8071 17.421 11.7241 17.212 11.7241H11.8539C11.436 11.7241 11.0351 11.5582 10.7396 11.2627C10.4441 10.9673 10.278 10.5666 10.278 10.1488V4.63498C10.2682 4.54166 10.24 4.45121 10.195 4.36888C10.15 4.28654 10.089 4.21396 10.0157 4.15535C9.94245 4.09673 9.85824 4.05324 9.76801 4.0274C9.67777 4.00157 9.5833 3.9939 9.49008 4.00483Z"
      stroke="#FF8A32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 4C14.1543 4.40644 15.2027 5.06664 16.068 5.93196C16.9334 6.79729 17.5936 7.84571 18 9H13.9091C13.668 9 13.4368 8.90422 13.2663 8.73373C13.0958 8.56325 13 8.33202 13 8.09091V4Z"
      stroke="#FF8A32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TransactionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4_281)">
      <path d="M23.2969 17.9063C23.6852 17.9063 24 17.5914 24 17.2031V15.3281C24 15.0618 23.8495 14.8184 23.6113 14.6992L18.9238 12.3555C18.7259 12.2565 18.4929 12.2565 18.2949 12.3555L13.6074 14.6992C13.3692 14.8184 13.2188 15.0618 13.2188 15.3281V17.2031C13.2188 17.5914 13.5336 17.9063 13.9219 17.9063H14.625V22.5938H13.9219C13.5336 22.5938 13.2188 22.9086 13.2188 23.2969C13.2188 23.6852 13.5336 24 13.9219 24H23.2969C23.6852 24 24 23.6852 24 23.2969C24 22.9086 23.6852 22.5938 23.2969 22.5938H22.5938V17.9063H23.2969ZM17.9062 22.5938H16.0312V17.9063H17.9062V22.5938ZM21.1875 22.5938H19.3125V17.9063H21.1875V22.5938ZM14.625 16.5V15.7627L18.6094 13.7705L22.5938 15.7627V16.5H14.625Z" fill="#EB5B00" />
      <path d="M10.7812 11.0154C10.7812 10.6271 10.4664 10.3123 10.0781 10.3123H9.375V5.62477H10.0781C10.4664 5.62477 10.7812 5.30996 10.7812 4.92164V3.04664C10.7812 2.7803 10.6308 2.53688 10.3926 2.41772L5.70506 0.0739707C5.50711 -0.0249824 5.27414 -0.0249824 5.07619 0.0739707L0.388687 2.41772C0.150469 2.53688 0 2.7803 0 3.04664V4.92164C0 5.30996 0.314812 5.62477 0.703125 5.62477H1.40625V10.3123H0.703125C0.314812 10.3123 0 10.6271 0 11.0154C0 11.4037 0.314812 11.7185 0.703125 11.7185H10.0781C10.4664 11.7185 10.7812 11.4037 10.7812 11.0154ZM1.40625 3.48122L5.39062 1.48903L9.375 3.48122V4.21852H1.40625V3.48122ZM4.6875 10.3123H2.8125V5.62477H4.6875V10.3123ZM7.96875 10.3123H6.09375V5.62477H7.96875V10.3123Z" fill="#EB5B00" />
      <path d="M11.0156 19.7813H6.09377V16.5569L6.76845 17.2316C7.04304 17.5061 7.48821 17.5061 7.76281 17.2316C8.0374 16.957 8.0374 16.5118 7.76281 16.2372L5.88781 14.3622C5.61326 14.0876 5.16804 14.0876 4.89345 14.3622L3.01845 16.2372C2.74385 16.5118 2.74385 16.957 3.01845 17.2316C3.29304 17.5061 3.73821 17.5061 4.01281 17.2316L4.68752 16.5569V20.4844C4.68752 20.8727 5.00234 21.1875 5.39065 21.1875H11.0156C11.404 21.1875 11.7188 20.8727 11.7188 20.4844C11.7188 20.0961 11.404 19.7813 11.0156 19.7813Z" fill="#EB5B00" />
      <path d="M17.9062 7.44314L17.2316 6.76847C16.957 6.49387 16.5118 6.49387 16.2372 6.76847C15.9626 7.04306 15.9626 7.48823 16.2372 7.76283L18.1122 9.63783C18.3868 9.91242 18.832 9.91242 19.1066 9.63783L20.9816 7.76283C21.2562 7.48823 21.2562 7.04306 20.9816 6.76847C20.707 6.49387 20.2618 6.49387 19.9872 6.76847L19.3125 7.44314V3.51562C19.3125 3.12731 18.9977 2.8125 18.6094 2.8125H12.9844C12.5961 2.8125 12.2812 3.12731 12.2812 3.51562C12.2812 3.90394 12.5961 4.21875 12.9844 4.21875H17.9062V7.44314Z" fill="#EB5B00" />
    </g>
    <defs>
      <clipPath id="clip0_4_281">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

)

export const ManageIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_379_777)">
      <path
        d="M2.75 8.25008C2.75 7.76385 2.94315 7.29754 3.28697 6.95372C3.63079 6.6099 4.0971 6.41675 4.58333 6.41675H17.4167C17.9029 6.41675 18.3692 6.6099 18.713 6.95372C19.0568 7.29754 19.25 7.76385 19.25 8.25008V16.5001C19.25 16.9863 19.0568 17.4526 18.713 17.7964C18.3692 18.1403 17.9029 18.3334 17.4167 18.3334H4.58333C4.0971 18.3334 3.63079 18.1403 3.28697 17.7964C2.94315 17.4526 2.75 16.9863 2.75 16.5001V8.25008Z"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33337 6.41667V4.58333C7.33337 4.0971 7.52653 3.63079 7.87035 3.28697C8.21416 2.94315 8.68048 2.75 9.16671 2.75H12.8334C13.3196 2.75 13.7859 2.94315 14.1297 3.28697C14.4736 3.63079 14.6667 4.0971 14.6667 4.58333V6.41667"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11V11.01"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 11.9167C5.30895 13.2062 8.13453 13.8779 11 13.8779C13.8655 13.8779 16.6911 13.2062 19.25 11.9167"
        stroke={"#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_379_777">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5715 10.2856C10.7017 10.2856 12.4286 8.55867 12.4286 6.42843C12.4286 4.29819 10.7017 2.57129 8.5715 2.57129C6.44126 2.57129 4.71436 4.29819 4.71436 6.42843C4.71436 8.55867 6.44126 10.2856 8.5715 10.2856Z"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2857 23.1424H0.857178V21.4282C0.857178 19.3822 1.66993 17.42 3.11664 15.9733C4.56335 14.5266 6.52551 13.7139 8.57146 13.7139C10.6174 13.7139 12.5796 14.5266 14.0263 15.9733C15.473 17.42 16.2857 19.3822 16.2857 21.4282V23.1424Z"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4287 2.57129C16.4517 2.57129 17.4328 2.97767 18.1561 3.70102C18.8795 4.42437 19.2859 5.40545 19.2859 6.42843C19.2859 7.45141 18.8795 8.43249 18.1561 9.15584C17.4328 9.8792 16.4517 10.2856 15.4287 10.2856"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1714 14.04C19.6317 14.5956 20.8889 15.5814 21.7766 16.8671C22.6643 18.1527 23.1407 19.6777 23.1428 21.24V23.1429H20.5714"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProductIcon = ({ props }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.39 2.99998C13.3367 2.92768 13.2638 2.87215 13.18 2.83998L7.18 0.569978C7.12323 0.545199 7.06195 0.53241 7 0.53241C6.93805 0.53241 6.87677 0.545199 6.82 0.569978L0.82 2.87998C0.74073 2.90097 0.668333 2.94234 0.61 2.99998C0.540148 3.08448 0.501329 3.19035 0.5 3.29998V10.62C0.501297 10.7198 0.532471 10.817 0.589505 10.899C0.646539 10.981 0.72682 11.044 0.82 11.08L6.82 13.39H7H7.18L13.18 11.08C13.2732 11.044 13.3535 10.981 13.4105 10.899C13.4675 10.817 13.4987 10.7198 13.5 10.62V3.33998C13.5085 3.21671 13.4691 3.09493 13.39 2.99998V2.99998Z"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13.46V5.5"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 5.5V13.46"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.609985 3.03998L6.99999 5.49998L13.39 3.03998"
        stroke="#000001"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SidebarHideShow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.80478 5.13807C6.06513 4.87772 6.06513 4.45561 5.80478 4.19526C5.54443 3.93491 5.12232 3.93491 4.86197 4.19526L1.52864 7.5286C1.26829 7.78894 1.26829 8.21106 1.52864 8.4714L4.86197 11.8047C5.12232 12.0651 5.54443 12.0651 5.80478 11.8047C6.06513 11.5444 6.06513 11.1223 5.80478 10.8619L2.94285 8L5.80478 5.13807Z"
      fill={"#000000"}
    />
    <path
      d="M11.1381 4.19526C10.8778 3.93491 10.4557 3.93491 10.1953 4.19526C9.93495 4.45561 9.93495 4.87772 10.1953 5.13807L13.0572 8L10.1953 10.8619C9.93495 11.1223 9.93495 11.5444 10.1953 11.8047C10.4557 12.0651 10.8778 12.0651 11.1381 11.8047L14.4714 8.4714C14.7318 8.21106 14.7318 7.78894 14.4714 7.5286L11.1381 4.19526Z"
      fill={"#000000"}
    />
  </svg>
);

export const ExportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 14L12 4M12 4L15 7M12 4L9 7"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SidebarArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 15.9999C9.49924 15.8683 9.52446 15.7379 9.57423 15.616C9.62399 15.4942 9.69732 15.3834 9.79 15.2899L13.1 11.9999L9.92 8.69994C9.73375 8.51258 9.62921 8.25912 9.62921 7.99494C9.62921 7.73075 9.73375 7.4773 9.92 7.28994C10.013 7.19621 10.1236 7.12182 10.2454 7.07105C10.3673 7.02028 10.498 6.99414 10.63 6.99414C10.762 6.99414 10.8927 7.02028 11.0146 7.07105C11.1364 7.12182 11.247 7.19621 11.34 7.28994L15.2 11.2899C15.3832 11.4769 15.4859 11.7282 15.4859 11.9899C15.4859 12.2517 15.3832 12.503 15.2 12.6899L11.2 16.6899C11.107 16.7837 10.9964 16.8581 10.8746 16.9088C10.7527 16.9596 10.622 16.9857 10.49 16.9857C10.358 16.9857 10.2273 16.9596 10.1054 16.9088C9.98356 16.8581 9.87296 16.7837 9.78 16.6899C9.60132 16.5046 9.50102 16.2574 9.5 15.9999Z"
      fill="white"
    />
  </svg>
);

export const DefaultPage = () => (
  <svg
    fill="#fff"
    height="120px"
    width="120px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 484.656 484.656"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M451.074,438.034h-9.837V195.806h-0.008c-12.084,0-23.525-3.944-33.045-10.585c-6.411,4.508-13.791,7.84-21.954,9.467
		c-3.746,0.746-7.553,1.118-11.322,1.118c-2.499,0-4.943-0.278-7.371-0.595v180.184c0,10.282-8.339,18.62-18.629,18.62h-66.923
		v-51.032l23.595,39.378c2.785,4.657,7.72,7.236,12.782,7.236c2.595,0,5.237-0.683,7.634-2.119
		c7.045-4.228,9.338-13.362,5.108-20.414l-47.429-79.167c-2.936-4.912-8.268-7.339-13.607-7.037
		c-0.357-0.033-54.953-0.041-55.286-0.017c-5.411-0.372-10.822,2.079-13.805,7.054l-47.43,79.167
		c-4.229,7.052-1.937,16.186,5.109,20.414c2.397,1.436,5.039,2.119,7.634,2.119c5.062,0,9.997-2.579,12.782-7.236l23.746-39.631
		v51.285h-67.066c-10.291,0-18.629-8.337-18.629-18.62V195.211c-2.427,0.317-4.872,0.595-7.371,0.595
		c-3.745,0-7.554-0.372-11.361-1.126c-8.157-1.626-15.52-4.951-21.923-9.459c-9.52,6.641-20.953,10.585-33.038,10.585h-0.008
		v242.228h-9.837c-12.877,0-23.311,10.433-23.311,23.311c0,12.877,10.434,23.311,23.311,23.311h417.492
		c12.878,0,23.311-10.434,23.311-23.311C474.385,448.467,463.952,438.034,451.074,438.034z"
      />
      <path
        d="M242.321,197.226c-17.115,0-31.007,15.877-31.007,35.474c0,19.581,13.892,35.473,31.007,35.473
		c17.13,0,31.015-15.892,31.015-35.473C273.335,213.103,259.451,197.226,242.321,197.226z"
      />
      <path
        d="M33.938,169.553c3.167,0.936,6.356,1.387,9.506,1.387c14.265,0,27.453-9.29,31.744-23.666l1.745-5.832
		c1.563,13.973,11.798,25.968,26.318,28.857c2.181,0.436,4.363,0.642,6.506,0.642c15.495,0,29.34-10.916,32.482-26.682l0.809-4.054
		c1.143,15.78,13.409,28.952,29.689,30.57c1.12,0.11,2.23,0.158,3.333,0.158c16.821,0,31.237-12.757,32.943-29.863l0.246-2.46
		c0.452,17.923,15.044,32.323,33.07,32.323c18.025,0,32.617-14.4,33.069-32.323l0.245,2.46
		c1.707,17.106,16.123,29.863,32.944,29.863c1.103,0,2.213-0.047,3.332-0.158c16.28-1.618,28.555-14.79,29.689-30.57l0.809,4.054
		c3.143,15.773,16.987,26.682,32.481,26.682c2.144,0,4.326-0.206,6.507-0.642c14.52-2.889,24.764-14.884,26.318-28.857l1.745,5.832
		c4.292,14.377,17.479,23.666,31.744,23.666c3.149,0,6.339-0.452,9.506-1.387c17.549-5.246,27.515-23.716,22.279-41.25
		L443.076,28.158C438.086,11.449,422.718,0,405.279,0H79.377C61.938,0,46.57,11.449,41.58,28.158L11.659,128.303
		C6.423,145.837,16.389,164.307,33.938,169.553z"
      />
    </g>
  </svg>
);
export const DefaultImage = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4625 11.6214C11.4625 13.4623 10.0299 14.9546 8.26265 14.9546C6.49541 14.9546 5.06278 13.4623 5.06278 11.6214C5.06278 9.78057 6.49541 8.28825 8.26265 8.28825C10.0299 8.28825 11.4625 9.78057 11.4625 11.6214Z"
      fill="#C2CBD9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.000732422 6.00019C0.000732422 4.15932 1.43337 2.66699 3.20061 2.66699H28.7996C30.5668 2.66699 31.9995 4.15932 31.9995 6.00019V25.9994C31.9995 27.8403 30.5669 29.3326 28.7996 29.3326H26.6874C26.6804 29.3326 26.6734 29.3326 26.6664 29.3326H3.92988C3.92386 29.3326 3.91783 29.3326 3.91181 29.3326H3.20061C1.43337 29.3326 0.000732422 27.8403 0.000732422 25.9994V6.00019ZM3.20061 5.16689H28.7996C29.2414 5.16689 29.5996 5.53997 29.5996 6.00019V16.3866L22.6474 9.33343L10.8198 21.3329L7.33568 17.7982L2.40064 22.805V6.00019C2.40064 5.53997 2.7588 5.16689 3.20061 5.16689Z"
      fill="#C2CBD9"
    />
  </svg>
);
export const DeleteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.187 8H17.812L17.117 19.125C17.0852 19.6328 16.8611 20.1094 16.4902 20.4577C16.1194 20.8061 15.6298 21 15.121 21H8.879C8.37022 21 7.88058 20.8061 7.50975 20.4577C7.13893 20.1094 6.9148 19.6328 6.883 19.125L6.187 8ZM19 5V7H5V5H8V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V5H19ZM10 5H14V4H10V5Z"
      fill="#EB5757"
    />
  </svg>
);
export const HorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={12} fill="#fff" />
    <path
      d="M17.6 16.2H6.4M17.6 12H6.4m11.2-4.2H6.4"
      stroke="#EB5A02"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export const VerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={24}
      width={24}
      height={24}
      rx={12}
      transform="rotate(90 24 0)"
      fill="#F5F5F5"
    />
    <path
      d="M7.8 17.6V6.4M12 17.6V6.4m4.2 11.2V6.4"
      stroke="#EB5A02"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export const MinusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_829_20251)">
      <path
        d="M4.16699 9.99988H15.8337"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_20251">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const PlusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_829_20245)">
      <path
        d="M10 4.16655V15.8332"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16699 9.99988H15.8337"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_20245">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LeftArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33301 5L3.33301 10L8.33301 15"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.667 10H3.33366"
      stroke="black"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8651 12.7436C14.8545 11.4675 15.3208 9.8622 15.1691 8.25433C15.0175 6.64647 14.2592 5.1568 13.0486 4.08839C11.8379 3.01998 10.2659 2.45309 8.65235 2.50304C7.03875 2.55299 5.50478 3.21604 4.36252 4.35728C3.21925 5.49932 2.55431 7.03449 2.50318 8.64995C2.45206 10.2654 3.0186 11.8396 4.08736 13.0517C5.15613 14.2638 6.64667 15.0226 8.25525 15.1734C9.86382 15.3243 11.4694 14.8559 12.7447 13.8636L12.7788 13.8994L16.1447 17.2674C16.2184 17.3411 16.306 17.3996 16.4023 17.4395C16.4986 17.4795 16.6018 17.5 16.7061 17.5C16.8103 17.5 16.9136 17.4795 17.0099 17.4395C17.1062 17.3996 17.1937 17.3411 17.2675 17.2674C17.3412 17.1936 17.3997 17.1061 17.4396 17.0097C17.4795 16.9134 17.5 16.8101 17.5 16.7058C17.5 16.6015 17.4795 16.4982 17.4396 16.4018C17.3997 16.3055 17.3412 16.2179 17.2675 16.1442L13.9008 12.7769C13.8892 12.7655 13.8773 12.7544 13.8651 12.7436ZM12.2178 5.48049C12.6658 5.92142 13.0221 6.44672 13.2662 7.02609C13.5102 7.60546 13.6372 8.22744 13.6397 8.85615C13.6423 9.48485 13.5204 10.1078 13.2811 10.6892C13.0418 11.2705 12.6898 11.7987 12.2454 12.2433C11.801 12.6878 11.273 13.04 10.6919 13.2794C10.1108 13.5188 9.48804 13.6408 8.85959 13.6382C8.23113 13.6356 7.6094 13.5086 7.03026 13.2645C6.45112 13.0203 5.92603 12.6639 5.48527 12.2157C4.60446 11.3201 4.11309 10.1126 4.11821 8.85615C4.12332 7.59973 4.6245 6.39623 5.51258 5.5078C6.40065 4.61937 7.60367 4.11799 8.85959 4.11288C10.1155 4.10776 11.3226 4.59932 12.2178 5.48049Z"
      fill="#999999"
    />
  </svg>
);
export const TickIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6113 23.7975C11.0023 23.7975 10.4255 23.5133 10.0559 23.0233L5.0537 16.4139C4.89905 16.2098 4.78614 15.9772 4.72144 15.7294C4.65673 15.4816 4.6415 15.2235 4.6766 14.9698C4.71171 14.7162 4.79646 14.4719 4.92603 14.251C5.0556 14.0301 5.22743 13.8369 5.4317 13.6825C5.6359 13.5274 5.86871 13.4141 6.11676 13.3492C6.36482 13.2842 6.62325 13.2689 6.87726 13.304C7.13126 13.3391 7.37584 13.424 7.59697 13.5538C7.8181 13.6836 8.01144 13.8558 8.1659 14.0605L11.4573 18.4061L19.7327 5.11728C20.0072 4.67852 20.4444 4.36653 20.9486 4.24973C21.4528 4.13294 21.9827 4.22089 22.4221 4.49428C23.3363 5.06268 23.6177 6.26668 23.0465 7.18228L13.2689 22.8763C13.102 23.1454 12.8719 23.3697 12.5987 23.5297C12.3254 23.6898 12.0173 23.7807 11.7009 23.7947C11.6701 23.7975 11.6421 23.7975 11.6113 23.7975Z"
      fill="#999999"
    />
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.8337 13.9998C26.8337 21.0874 21.0879 26.8331 14.0003 26.8331C6.91267 26.8331 1.16699 21.0874 1.16699 13.9998C1.16699 6.91214 6.91267 1.16646 14.0003 1.16646C21.0879 1.16646 26.8337 6.91214 26.8337 13.9998ZM3.50829 13.9998C3.50829 19.7944 8.20574 24.4919 14.0003 24.4919C19.7949 24.4919 24.4924 19.7944 24.4924 13.9998C24.4924 8.2052 19.7949 3.50776 14.0003 3.50776C8.20574 3.50776 3.50829 8.2052 3.50829 13.9998Z"
      fill="#999999"
    />
    <path
      d="M13.9997 5.83354C13.3553 5.83354 12.833 6.35587 12.833 7.00021V14.5447C12.833 14.5447 12.833 14.8488 12.9808 15.0776C13.0798 15.2716 13.234 15.4402 13.4366 15.5572L18.8264 18.6691C19.3844 18.9912 20.098 18.8 20.4201 18.242C20.7422 17.684 20.5511 16.9704 19.9931 16.6483L15.1663 13.8616V7.00021C15.1663 6.35588 14.644 5.83354 13.9997 5.83354Z"
      fill="#999999"
    />
  </svg>
);
export const TruckIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4031 5.41406V19.5563H10.1172H9.76719C9.66875 19.5563 9.58125 19.4906 9.55937 19.3922C9.275 17.7734 7.875 16.5594 6.17969 16.5594C4.48438 16.5594 3.09531 17.7734 2.81094 19.3813C2.78906 19.4797 2.7125 19.5453 2.60312 19.5453H0.896875C0.39375 19.5453 0 19.1406 0 18.6484V5.41406H12.4031ZM25.6812 20.0047C25.6812 21.4266 24.5328 22.575 23.1109 22.575C21.6891 22.575 20.5406 21.4266 20.5406 20.0047C20.5406 18.5828 21.6891 17.4344 23.1109 17.4344C24.5328 17.4344 25.6812 18.5828 25.6812 20.0047ZM24.0953 20.0047C24.0953 19.4688 23.6469 19.0203 23.1109 19.0203C22.575 19.0203 22.1266 19.4688 22.1266 20.0047C22.1266 20.5406 22.575 20.9891 23.1109 20.9891C23.6578 20.9891 24.0953 20.5406 24.0953 20.0047ZM8.75 20.0047C8.75 21.4266 7.60156 22.575 6.17969 22.575C4.75781 22.575 3.60938 21.4266 3.60938 20.0047C3.60938 18.5828 4.75781 17.4344 6.17969 17.4344C7.60156 17.4344 8.75 18.5828 8.75 20.0047ZM7.16406 20.0047C7.16406 19.4688 6.71562 19.0203 6.17969 19.0203C5.64375 19.0203 5.19531 19.4688 5.19531 20.0047C5.19531 20.5406 5.64375 20.9891 6.17969 20.9891C6.71562 20.9891 7.16406 20.5406 7.16406 20.0047ZM28 17.9047V18.5938C28 19.1188 27.5844 19.5453 27.0484 19.5453H26.6875C26.5891 19.5453 26.5016 19.4797 26.4797 19.3813C26.1953 17.7734 24.7953 16.5484 23.1109 16.5484C21.4266 16.5484 20.0156 17.7734 19.7422 19.3813C19.7203 19.4797 19.6438 19.5453 19.5344 19.5453H13.2016V8.75H17.0844C17.3578 8.76094 17.6203 8.87031 17.8062 9.05625L21.9625 13.5406C21.9953 13.5734 22.0609 13.6063 22.1156 13.6063H25.7578C26.5891 13.6063 27.2563 14.2734 27.2563 15.0938V17.7188H27.8031C27.9016 17.7078 28 17.8063 28 17.9047ZM20.125 13.2453L17.1172 9.93125C17.0734 9.89844 17.0187 9.86563 16.9531 9.86563H14.5578C14.4484 9.86563 14.35 9.96406 14.35 10.0734V13.3984C14.35 13.5078 14.4484 13.6063 14.5578 13.6063H19.9609C20.1469 13.6063 20.2344 13.3875 20.125 13.2453Z"
      fill="#999999"
    />
  </svg>
);
export const FlagIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1875 4.2C22.925 4.025 22.575 4.025 22.3125 4.2C19.25 6.125 16.975 4.9 14.4375 3.5C11.8125 2.1 8.75 0.525001 4.8125 2.8875C4.55 3.15 4.375 3.4125 4.375 3.7625V15.75V16.0125V25.375C4.375 25.9 4.725 26.25 5.25 26.25C5.775 26.25 6.125 25.9 6.125 25.375V16.5375C9.0125 14.9625 11.1125 16.1 13.5625 17.4125C15.225 18.2875 17.0625 19.25 19.1625 19.25C20.3875 19.25 21.7875 18.9 23.1875 18.025C23.45 17.85 23.625 17.5875 23.625 17.2375V4.9875C23.625 4.6375 23.45 4.375 23.1875 4.2Z"
      fill="#999999"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_73_12511)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0001 12.4963C9.49214 12.4963 7.72346 10.6903 7.45931 7.95567L7.08483 5.00119C6.85271 2.0985 9.22135 0 12.0001 0C14.7788 0 17.1475 2.0985 16.9152 5.00119L16.5408 7.95567C16.2765 10.6902 14.508 12.4963 12.0001 12.4963ZM21.5339 18.6666L21.7131 19.808C21.777 20.2154 21.6928 20.8134 21.3277 21.1123C21.2809 21.1506 21.2219 21.2081 21.1475 21.2808C20.4457 21.9659 18.3622 24.0001 12.0001 24.0001C5.63793 24.0001 3.55431 21.9659 2.85252 21.2808C2.77806 21.2081 2.71916 21.1506 2.67235 21.1123C2.30738 20.8134 2.22306 20.2154 2.28695 19.808L2.46629 18.6666C2.61643 17.7095 3.21784 16.8834 4.08231 16.4465L7.85443 14.539C7.97251 14.4793 8.06865 14.3893 8.14923 14.2888C9.24123 15.4434 10.5681 16.1226 12.0001 16.1226C13.4321 16.1226 14.7588 15.4434 15.8509 14.2888C15.9315 14.3893 16.0276 14.4793 16.1457 14.539L19.9179 16.4465C20.7822 16.8834 21.3837 17.7095 21.5339 18.6666Z"
        fill="#EB5B00"
      />
    </g>
    <defs>
      <clipPath id="clip0_73_12511">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const RightArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49998 15.9999C9.49922 15.8683 9.52445 15.7379 9.57421 15.616C9.62398 15.4942 9.6973 15.3834 9.78998 15.2899L13.1 11.9999L9.91998 8.69994C9.73373 8.51258 9.62919 8.25912 9.62919 7.99494C9.62919 7.73075 9.73373 7.4773 9.91998 7.28994C10.0129 7.19621 10.1235 7.12182 10.2454 7.07105C10.3673 7.02028 10.498 6.99414 10.63 6.99414C10.762 6.99414 10.8927 7.02028 11.0146 7.07105C11.1364 7.12182 11.247 7.19621 11.34 7.28994L15.2 11.2899C15.3832 11.4769 15.4858 11.7282 15.4858 11.9899C15.4858 12.2517 15.3832 12.503 15.2 12.6899L11.2 16.6899C11.107 16.7837 10.9964 16.8581 10.8746 16.9088C10.7527 16.9596 10.622 16.9857 10.49 16.9857C10.358 16.9857 10.2273 16.9596 10.1054 16.9088C9.98355 16.8581 9.87295 16.7837 9.77998 16.6899C9.6013 16.5046 9.50101 16.2574 9.49998 15.9999Z"
      fill="black"
    />
  </svg>
);
export const MinimumDollarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 14H10C9.71667 14 9.47917 14.0958 9.2875 14.2875C9.09583 14.4792 9 14.7167 9 15C9 15.2833 9.09583 15.5208 9.2875 15.7125C9.47917 15.9042 9.71667 16 10 16H11C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17C12.2667 17 12.4542 16.8792 12.5625 16.6375C12.6708 16.3958 12.8167 16.1833 13 16H14C14.2833 16 14.5208 15.9042 14.7125 15.7125C14.9042 15.5208 15 15.2833 15 15V12C15 11.7167 14.9042 11.4792 14.7125 11.2875C14.5208 11.0958 14.2833 11 14 11H11V10H14C14.2833 10 14.5208 9.90417 14.7125 9.7125C14.9042 9.52083 15 9.28333 15 9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8H13C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7333 7 11.5458 7.12083 11.4375 7.3625C11.3292 7.60417 11.1833 7.81667 11 8H10C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13H13V14ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
      fill="#00C537"
    />
  </svg>
);
export const WarningIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.725 21C2.54167 21 2.375 20.9542 2.225 20.8625C2.075 20.7708 1.95834 20.65 1.875 20.5C1.79167 20.35 1.74584 20.1875 1.7375 20.0125C1.72917 19.8375 1.775 19.6667 1.875 19.5L11.125 3.5C11.225 3.33333 11.3542 3.20833 11.5125 3.125C11.6708 3.04167 11.8333 3 12 3C12.1667 3 12.3292 3.04167 12.4875 3.125C12.6458 3.20833 12.775 3.33333 12.875 3.5L22.125 19.5C22.225 19.6667 22.2708 19.8375 22.2625 20.0125C22.2542 20.1875 22.2083 20.35 22.125 20.5C22.0417 20.65 21.925 20.7708 21.775 20.8625C21.625 20.9542 21.4583 21 21.275 21H2.725ZM12 18C12.2833 18 12.5208 17.9042 12.7125 17.7125C12.9042 17.5208 13 17.2833 13 17C13 16.7167 12.9042 16.4792 12.7125 16.2875C12.5208 16.0958 12.2833 16 12 16C11.7167 16 11.4792 16.0958 11.2875 16.2875C11.0958 16.4792 11 16.7167 11 17C11 17.2833 11.0958 17.5208 11.2875 17.7125C11.4792 17.9042 11.7167 18 12 18ZM12 15C12.2833 15 12.5208 14.9042 12.7125 14.7125C12.9042 14.5208 13 14.2833 13 14V11C13 10.7167 12.9042 10.4792 12.7125 10.2875C12.5208 10.0958 12.2833 10 12 10C11.7167 10 11.4792 10.0958 11.2875 10.2875C11.0958 10.4792 11 10.7167 11 11V14C11 14.2833 11.0958 14.5208 11.2875 14.7125C11.4792 14.9042 11.7167 15 12 15Z"
      fill="#FFB345"
    />
  </svg>
);

export const CopyIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.07143 22H17.3571C17.6413 22 17.9138 21.8871 18.1148 21.6862C18.3157 21.4853 18.4286 21.2127 18.4286 20.9286V6.28571C18.4286 6.09627 18.3533 5.91459 18.2194 5.78064C18.0854 5.64668 17.9037 5.57143 17.7143 5.57143H3.07143C2.78727 5.57143 2.51475 5.68431 2.31381 5.88524C2.11288 6.08617 2 6.3587 2 6.64286V20.9286C2 21.2127 2.11288 21.4853 2.31381 21.6862C2.51475 21.8871 2.78727 22 3.07143 22Z"
      fill="black"
    />
    <path
      d="M18.4286 4.14286H5.57143V3.07143C5.57143 2.78727 5.68431 2.51475 5.88524 2.31381C6.08617 2.11288 6.3587 2 6.64286 2H20.75C21.0815 2 21.3995 2.1317 21.6339 2.36612C21.8683 2.60054 22 2.91848 22 3.25V17.3571C22 17.6413 21.8871 17.9138 21.6862 18.1148C21.4853 18.3157 21.2127 18.4286 20.9286 18.4286H19.8571V5.57143C19.8571 5.19255 19.7066 4.82919 19.4387 4.56128C19.1708 4.29337 18.8075 4.14286 18.4286 4.14286Z"
      fill="black"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 7.91669C13.2237 7.91606 13.1149 7.93708 13.0134 7.97855C12.9119 8.02002 12.8195 8.08113 12.7417 8.15836L9.99999 10.9167L7.24999 8.26669C7.09385 8.11149 6.88264 8.02437 6.66249 8.02437C6.44233 8.02437 6.23113 8.11149 6.07499 8.26669C5.99688 8.34416 5.93489 8.43633 5.89258 8.53788C5.85027 8.63943 5.82849 8.74835 5.82849 8.85836C5.82849 8.96837 5.85027 9.07729 5.89258 9.17884C5.93489 9.28039 5.99688 9.37256 6.07499 9.45003L9.40832 12.6667C9.5641 12.8194 9.77353 12.9049 9.99166 12.9049C10.2098 12.9049 10.4192 12.8194 10.575 12.6667L13.9083 9.33336C13.9864 9.25589 14.0484 9.16372 14.0907 9.06217C14.133 8.96062 14.1548 8.8517 14.1548 8.74169C14.1548 8.63168 14.133 8.52276 14.0907 8.42121C14.0484 8.31966 13.9864 8.2275 13.9083 8.15003C13.7538 8.00113 13.5479 7.91755 13.3333 7.91669Z"
      fill="black"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.189 5.51721L10.2218 4.94064L8.44835 1.34533C8.39991 1.24689 8.32022 1.16721 8.22178 1.11877C7.97491 0.996893 7.67491 1.09846 7.55147 1.34533L5.77803 4.94064L1.81084 5.51721C1.70147 5.53283 1.60147 5.58439 1.52491 5.66252C1.43235 5.75765 1.38134 5.88564 1.3831 6.01836C1.38486 6.15109 1.43924 6.27768 1.53428 6.37033L4.4046 9.16877L3.72647 13.1203C3.71057 13.2123 3.72074 13.3068 3.75583 13.3932C3.79093 13.4797 3.84953 13.5545 3.92501 13.6094C4.00049 13.6642 4.08982 13.6967 4.18288 13.7034C4.27593 13.71 4.36898 13.6904 4.45147 13.6469L7.99991 11.7813L11.5483 13.6469C11.6452 13.6985 11.7577 13.7156 11.8655 13.6969C12.1374 13.65 12.3202 13.3922 12.2733 13.1203L11.5952 9.16877L14.4655 6.37033C14.5437 6.29377 14.5952 6.19377 14.6108 6.08439C14.653 5.81096 14.4624 5.55783 14.189 5.51721Z"
      fill="#F7D14B"
    />
  </svg>
);
